// FLAGS: silent-failure
// Single flag read against the API's Azure App Configuration passthrough; `placeholderData: false` makes it fail closed.
import { useQuery } from "@tanstack/react-query";
import { Featureflags } from "@src/api/v1/Featureflags";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import { fiveMinutes } from "./staletimes";

export const useFeatureFlagQuery = (flagName: string) =>
  useQuery({
    queryKey: ["featureFlag", flagName],
    queryFn: async () => {
      const response = await new Featureflags(OpenUpHttpClient).get(flagName);
      return response as unknown as boolean;
    },
    staleTime: fiveMinutes,
    placeholderData: false,
  });
